import React from 'react';
import { Trophy, Calendar, Calculator } from 'lucide-react';
const bonuses = [{
  icon: <Trophy className="w-7 h-7 text-brand-purple" data-id="element-32" />,
  title: 'Scripts de Clientas VIP (Copy & Paste)',
  value: '$16.000',
  desc: 'Mensajes listos para copiar y pegar en WhatsApp o Instagram para:',
  bullets: ['Ofrecer membresías sin incomodidad', 'Cerrar clientas fijas automáticamente', 'Subir precios sin perder clientas', 'Responder cancelaciones como profesional'],
  cta: 'Nunca más vas a dudar qué decir'
}, {
  icon: <Calendar className="w-7 h-7 text-brand-purple" data-id="element-33" />,
  title: 'Agenda Premium Editable (Lista para Usar)',
  value: '$12.000',
  desc: 'Una agenda ya organizada para que empieces hoy mismo:',
  bullets: ['Bloques de horarios optimizados', 'Espacios para clientas fijas', 'Formato simple y fácil de usar'],
  cta: 'Solo abrís, completás y empezás a trabajar con orden'
}, {
  icon: <Calculator className="w-7 h-7 text-brand-purple" data-id="element-34" />,
  title: 'Calculadora de Ingresos para Uñas',
  value: '$8.000',
  desc: 'Una herramienta simple para que veas exactamente:',
  bullets: ['Cuántas clientas necesitás', 'Cuánto podés ganar por mes', 'Cómo lograr ingresos estables'],
  cta: 'Vas a tener claridad total sobre tu dinero'
}];
export function BonusesSection() {
  const scrollToPurchase = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-14 px-4 sm:px-6 lg:px-8 bg-brand-cream relative overflow-hidden" data-id="element-35">
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-roseGold via-brand-purple to-brand-gold" data-id="element-36"></div>

      <div className="max-w-6xl mx-auto" data-id="element-37">
        <div className="text-center mb-10" data-id="element-38">
          <div className="inline-block bg-red-600 text-white font-bold px-5 py-1.5 rounded-full text-sm uppercase tracking-wider mb-4 animate-pulse" data-id="element-39">
            ¡Atención! Bonos Exclusivos Gratis Por Hoy
          </div>
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-brand-purple mb-3" data-id="element-40">
            Llevate todo esto de regalo con tu compra
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto" data-id="element-41">
            Para asegurarnos de que tengas éxito absoluto, si comprás hoy te
            llevás estos 3 complementos totalmente GRATIS.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-42">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white rounded-2xl p-5 shadow-xl border-t-4 border-brand-roseGold hover:-translate-y-2 transition-transform duration-300 cursor-pointer flex flex-col" onClick={scrollToPurchase} data-id="element-43">
              <h3 className="text-lg font-bold text-gray-900 leading-tight mb-3" data-id="element-44">
                {bonus.title}
              </h3>
              <p className="text-gray-600 text-sm mb-2" data-id="element-45">{bonus.desc}</p>
              <ul className="space-y-1.5 mb-3" data-id="element-46">
                {bonus.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-47">
                    <span className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-48">
                      ✔
                    </span>
                    <span data-id="element-49">{bullet}</span>
                  </li>)}
              </ul>
              <p className="mt-auto text-sm font-semibold text-brand-purple flex items-center gap-1" data-id="element-50">
                👉 {bonus.cta}
              </p>
              <div className="mt-3 pt-3 border-t border-gray-100 flex justify-between items-center" data-id="element-51">
                <span className="text-gray-400 line-through text-sm" data-id="element-52">
                  Valor: {bonus.value}
                </span>
                <span className="text-green-600 font-black uppercase text-sm" data-id="element-53">
                  ¡GRATIS HOY!
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}